// src/hooks/useAuth.js
import { useState, useEffect } from 'react';
import api from '../utils/api';

export default function useAuth() {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loggedInUser, setLoggedInUser] = useState(null);


  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('token');

      if (token) {
        try {
          // Aplica o token no header
          api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

          // Faz a verificação no backend
          const response = await api.get('/verify-token');
          
          // Verifica se o retorno é válido
          if (response.data && response.data.valid === true) {     
            setLoggedInUser(response.data?.user || null)
            setAuthenticated(true);
          } else {
            // Caso o token seja inválido
            setAuthenticated(false);
            localStorage.removeItem("token");
            console.warn("Token inválido.");
          }

        } catch (error) {
          // Captura erros da requisição (ex: 401, timeout, rede)
          setAuthenticated(false);
          localStorage.removeItem("token");
          setLoggedInUser(null)
          console.error("Erro ao verificar token:", error);
        }
      }

      // Finaliza o carregamento
      setLoading(false);
    };

    verifyToken(); // 👈 chama a função assíncrona 
  }, []);


  async function login(user) {
    try {
      const response = await api.post('/login', user);

      if (response.data.token) {
        await authUser(response.data.token, response.data);
        return { success: true };
      }

      return {
        success: false,
        message: response.data.message || 'Erro ao fazer login'
      };
    } catch (err) {
      console.error('Erro no login:', err);

      // Verifica se existe response (erro do servidor)
      if (err.response && err.response.data) {
        return {
          success: false,
          message: err.response.data.message || 'Erro ao fazer login'
        };
      }

      // Erro de rede ou outro erro
      return {
        success: false,
        message: 'Erro de conexão. Verifique sua internet.'
      };
    }
  }

  async function authUser(token, user) {
    localStorage.setItem('token', JSON.stringify(token));
    api.defaults.headers.Authorization = `Bearer ${token}`;
    const response = await api.get('/verify-token');
    setAuthenticated(true);
    setLoggedInUser(response.data?.user)
  }

  function logout() {
    localStorage.removeItem('token');
    api.defaults.headers.Authorization = undefined;
    setAuthenticated(false);
    setLoggedInUser(null)
  }

  return { authenticated, loading, loggedInUser, login, logout };
}